import { regExpPatternFromWildcardName } from "../utils/regExpPatternFromWildcardName.js";
/**
 * Synchronously check if a content is blocked and returns the found content blocker.
 * See `window.consentApi.unblock` for more documentation.
 */ function unblockSync(blocker, url, options) {
    const { mapRule } = options || {};
    if (!url) {
        return undefined;
    }
    // Find matching blocker
    let found;
    loop1: for (const row of blocker){
        const { rules } = row;
        // Check if host matches
        for (const rule of rules){
            const useRule = mapRule ? mapRule(rule) : rule;
            if (!useRule) {
                continue;
            }
            const regexp = regExpPatternFromWildcardName(useRule);
            if (url.match(new RegExp(regexp, "s"))) {
                found = row;
                break loop1;
            }
        }
    }
    return found;
}
export { unblockSync };
